import { ApplicationConfig, isDevMode } from '@angular/core';
import { RouteReuseStrategy, provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { mainInterceptor } from '@services/main.interceptor';
import {
  APP_CONFIG,
  APP_CONFIG_SERIVCE,
} from '@services/common/appconfig.service';
import { provideServiceWorker } from '@angular/service-worker';
import { CustomRouteReuseStrategy } from '@core/strategies/custom-route-reuse-strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
    provideAnimations(),
    // provideHttpClient(withFetch()),
    // provideHttpClient(withInterceptorsFromDi()),
    provideHttpClient(withInterceptors([mainInterceptor])),
    { provide: APP_CONFIG_SERIVCE, useValue: APP_CONFIG },
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
    }),
  ],
};
